
import Empty from '@/common/components/Empty';
import { List, Spin } from 'antd';
import { FC, useEffect, useRef, useState } from 'react';
import styles from './index.module.less';
import { useMethods } from '@lhb/hook';
import { isArray } from '@lhb/func';
import VirtualList from 'rc-virtual-list';
import ListItem from './ListItem';
import { NOT_MORE_DATA } from '../../../../ts-config';
import { getSpotEvaluationAroundPage, getSpotEvaluationAroundPageShare } from '@/common/api/spotevaluation';
import { SpotTypeEnum } from '@/views/spotevaluation/pages/index/ts-config';

interface CommunityProps {
  mainHeight: number;
  detail: any;
  filters: any;
  curDetail: any;
  setCurDetail: Function;
  tenantId?: number;
  isShare?: boolean;
  drawerData?: any;
}

/**
 * @Description 小区卡片
 */
const Community:FC<CommunityProps> = ({
  tenantId,
  detail,
  filters,
  setCurDetail,
  curDetail,
  mainHeight,
  drawerData = {}
}) => {
  const ContainerHeight = mainHeight - 100;// tab和分页高度
  const pageRef: any = useRef<number>(1); // 虚拟列表下拉筛选的分页page
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [list, setList] = useState<any[]>([]);


  const methods = useMethods({
    onScroll(e: any) {
      // 预留10px
      if (e.currentTarget.scrollHeight - e.currentTarget.scrollTop <= ContainerHeight + 10) {
        if (isLoading) return;
        if (pageRef.current !== NOT_MORE_DATA) {
          pageRef.current += 1;
          methods.loadCommonRimApiData(list);
        }
      }
    },
    loadCommonRimApiData: async (lastData) => {
      const sizeVal = 200;
      try {
        let _params: any = {};
        const targetFeatch = tenantId ? getSpotEvaluationAroundPageShare : getSpotEvaluationAroundPage;
        const { type, modelConfigId, modelClusterId, radius } = drawerData;
        _params = {
          page: pageRef.current,
          size: sizeVal,
          poiSearchType: 1,
          lat: detail.lat,
          lng: detail.lng,
          aoiTypeCategoryId: 1,
          // secondAoiType: filters.secondAoiType,
          cityName: detail.cityName,
          type,
          modelConfigId,
          radius, // 先兼容接口在type2时也要求传radius的报错
        };
        if (type === SpotTypeEnum.Mall) {
          _params.modelClusterId = modelClusterId;
          _params.radius = filters.distance;
        }
        if (type === SpotTypeEnum.Street) {
          _params.radius = radius;
        }
        if (tenantId) {
          _params.tenantId = tenantId;
        }
        const { objectList } = await targetFeatch(_params, false);
        const targetData = isArray(objectList) ? objectList : [];
        // 将数据合并为一行两个的二维数组
        const rowData = targetData.reduce((acc, cur, idx) => {
          if (idx % 2 === 0) {
            acc.push([cur]);
          } else {
            acc[acc.length - 1].push(cur);
          }
          return acc;
        }, []);
        const totalData = [...lastData, ...rowData];
        // 返回的数据等于size，说明可能还有下一页
        // if (targetData.length === sizeVal && totalData.length < totalNum / 2) {
        //   methods.loadCommonRimApiData(totalData);
        // } else {
        setList(() => (totalData));
        setIsLoading(false);
        // }
      } catch (error) {
        setIsLoading(false);
      }
    },
  });

  useEffect(() => {
    methods.loadCommonRimApiData([]);
  }, []);

  return (
    <div className={styles.communityCon}>
      <Spin
        spinning={isLoading}>
        {Array.isArray(list) && list.length
          ? <VirtualList
            data={list}
            height={ContainerHeight}
            itemHeight={64}
            itemKey='id'
            onScroll={methods.onScroll}
            className={styles.listCon}
          >
            {(item: any, index:number) => (
              <List.Item
                key={index}
              >
                <ListItem
                  row={item}
                  curDetail={curDetail}
                  setCurDetail={setCurDetail}
                />
              </List.Item>
            )}
          </VirtualList>
          : <Empty />
        }
      </Spin>
    </div>
  );
};


export default Community;
